import { ModelResource } from './resource';
import { LedgerAccount } from '../models';

export class LedgerAccounts extends ModelResource<LedgerAccount> {
  model = LedgerAccount;

  resourcePath = 'v1/ledger-accounts';
}
